<div class="overlay" *ngIf="isLoading | async">
  <div class="spinner">
    <div class="spinner-part spinner-part1"></div>
    <div class="spinner-part spinner-part2"></div>
    <img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
  </div>
</div>
<h2 mat-dialog-title>Follow Up
  <img class="close-button" (click)="onNoClick()" src="/assets/images/close.png" alt="">
</h2>
<mat-dialog-content>
  <form class="sales-manager-form" [formGroup]="followUpForm">

  <div class="formInput">
    <label class="form-label">Follow Up Reasons<span class="alert-small">*</span></label>
    <select class="form-select" formControlName="followup_reason"  [attr.value]="followUpForm.get('followup_reason')?.value"
    [ngClass]="{ 'is-invalid': submitted && f['followup_reason'].errors }"
       >
        <option disabled selected value="">Select</option>
        <option *ngFor="let followup_reason of followUpReason" [value]="followup_reason.id + ':' + followup_reason.reason">{{ followup_reason.reason }}</option>
      </select>
    <div *ngIf="submitted && f['followup_reason'].errors" class="invalid-feedback">
        <div *ngIf="followUpForm.get('followup_reason')?.errors?.['required']" class="error-msg">
            Please Select Follow Up Reason.
        </div>
    </div>
</div>
    <div class="row mb-3">
      <div class="col-md-6">
        <label for="followupdate" class="form-label">Follow Up Date<span class="alert-small">*</span></label>
        <div class="input-group">
          <input readonly class="form-control" style="cursor: pointer;" #inputField (click)="picker.open()" [attr.value]="followUpForm.get('followup_date')?.value"
            [matDatepicker]="picker" formControlName="followup_date" placeholder="Select Date"  [min]="minDate">
          <div class="input-group-prepend" (click)="picker.open()" style="cursor: pointer;">
            <span class="input-group-text">
              <i class="fa fa-calendar" aria-hidden="true"></i>
            </span>
          </div>
        </div>
        <mat-datepicker #picker></mat-datepicker>
        <div *ngIf="submitted && f['followup_date'].errors" >
          <div *ngIf="followUpForm.get('followup_date')?.errors?.['required']" class="error-msg"> 
            Please Select Follow Up Date.
            </div>
          </div>
      </div>
      <div class="col-md-6">
        <label for="followuptime" class="form-label">Follow Up Time<span class="alert-small">*</span></label>
        <mat-form-field appearance="outline">
          <input type="text" readonly [attr.value]="followUpForm.get('timeOfFollowUp')?.value"  formControlName="timeOfFollowUp" matInput [matTimepicker]="timepicker" (click)="timepicker.open()"
         />
          <mat-timepicker-toggle matSuffix [for]="timepicker"></mat-timepicker-toggle>
          <mat-timepicker #timepicker touchUi mode="input"></mat-timepicker>
          <!-- <mat-hint>hh:mm</mat-hint> -->
        </mat-form-field>
        <div style="margin-top:-20px"  *ngIf="submitted && f['timeOfFollowUp'].errors">
          <div *ngIf="followUpForm.get('timeOfFollowUp')?.errors?.['required']" class="error-msg"> 
            Please Select Follow Up Time.
            </div>
          </div>
        <!-- <div class="input-group time">
          <input type="time" id="appt" name="appt" formControlName="timeOfFollowUp">
        </div> -->
      </div>
    </div>
    <div class="mb-3">
      <label for="remarks" class="form-label">Remarks</label>
      <textarea class="form-control" id="remarks" rows="3" formControlName="remarks" [attr.value]="followUpForm.get('remarks')?.value" placeholder="Enter Text here"></textarea>
    </div>
  </form>
</mat-dialog-content>
<div mat-dialog-actions class="d-flex justify-content-end">
  <button class="btn white-btn mr-2" type="button" (click)="onNoClick()">Cancel</button>
  <button class="btn blue-btn mr-3" type="submit"  (click)="onSubmit()">Submit</button>


</div>